<template>
  <div class="footer">
    <nav class="nologin">
      <div class="btnpc" @click="toWeb">电脑版</div>
      <div class="color_999">©小猪</div>
      <div @click="toService">联系客服</div>
    </nav>
    <router-link to="/lisence" class="license"
      ><i class="vline lline"></i>营业执照<i
        class="vline rline"
      ></i
    ></router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    toWeb: function() {
      window.location.href = this.$store.state.mainUrl + "/?mobile=false";
    },
    toService: function() {
      this.$router.push({ name: "service" });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/footer.vue